import { useState, useEffect, useCallback, type ReactNode } from 'react';
import { BatchContext } from './BatchContext';
import { authHeaders } from '../utils/auth';
import { apiFetch } from '../utils/api';
import type { Batch } from '../types';

export function BatchProvider({ children }: { children: ReactNode }) {
    const [batches, setBatches] = useState<Batch[]>([]);
    const [batchId, setBatchId] = useState('');

    const refreshBatches = useCallback(() => {
        return apiFetch('/api/batches', { headers: authHeaders() })
            .then(r => r.json())
            .then((data: unknown) => setBatches(Array.isArray(data) ? data : []))
            .catch(() => {});
    }, []);

    useEffect(() => {
        refreshBatches();
    }, [refreshBatches]);

    const selectedBatch = batches.find(b => String(b.id) === String(batchId)) ?? null;

    const value = { batches, setBatches, batchId, setBatchId, selectedBatch, refreshBatches };

    return (
        <BatchContext.Provider value={value}>
            {children}
        </BatchContext.Provider>
    );
}
